// Formato del RFC de México (SAT). Mismo criterio que el backend
// (apps/torre-de-control-api/functions/src/utils/rfc.js):
//   • persona moral: 12 caracteres (3 letras + fecha AAMMDD + homoclave de 3);
//   • persona física: 13 caracteres (4 letras + fecha AAMMDD + homoclave de 3).
// Las letras admiten Ñ y &. El dígito verificador no se recalcula: el SAT tiene
// RFC vigentes que no cumplen el algoritmo y rechazarlos dejaría fuera a
// contribuyentes reales. Se valida la estructura y que la fecha exista.

const RFC_PATTERN = /^[A-ZÑ&]{3,4}(\d{2})(\d{2})(\d{2})[A-Z0-9]{2}[0-9A]$/;

const DAYS_IN_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

/** Mayúsculas y sin espacios, guiones ni puntos (como se suele capturar). */
export const normalizeRfc = (raw: unknown): string =>
  String(raw ?? "")
    .toUpperCase()
    .replace(/[\s.\-_]/g, "");

/** ¿Es un RFC con estructura y fecha válidas? Acepta el valor sin normalizar. */
export const isValidRfc = (raw: unknown): boolean => {
  const match = RFC_PATTERN.exec(normalizeRfc(raw));
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1 || day > DAYS_IN_MONTH[month - 1]) return false;
  // Dos dígitos de año: 00 es 2000 (bisiesto), y el resto sigue la regla de 4.
  if (month === 2 && day === 29 && year % 4 !== 0) return false;
  return true;
};
